// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  position: relative;
}

.wrap {
  width: 100%;
  height: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: inherit;
  font-style: inherit;
}
.wrap.disabled {
  cursor: not-allowed;
}
.wrap.disabled .icon-arrow {
  opacity: 0.4;
}
.wrap:focus-visible {
  outline: none;
}
.value {
  height: auto;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: var(--black);
  flex-grow: 1;
}
.value.placeholder {
  color: var(--grey-text);
}

.icon-arrow {
  font-size: 1.8rem;
  color: var(--dark);
  margin-left: 0.8rem;
}

.dropdown {
  max-height: 30.2rem;
  background: var(--white);
  border-radius: 0.8rem;
  box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 5.1rem;
  right: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
}

.option {
  min-height: 4.8rem;
  font-size: 1.4rem;
  line-height: 1.7rem;
  color: var(--black);
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}
.option:hover {
  background: var(--basic-button-hover);
}
.option.active {
  background: var(--primary-10);
  cursor: default;
}
.option.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/shared/select/select.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,YAAA;AACN;AAGE;EACE,aAAA;AADJ;AAuBA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AArBF;AAuBE;EACE,uBAAA;AArBJ;;AAyBA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AAtBF;AAwBE;EACE,qCAAA;AAtBJ;AAyBE;EACE,6BAAA;EACA,eAAA;AAvBJ;AA0BE;EACE,YAAA;EACA,mBAAA;AAxBJ","sourcesContent":[":host {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.wrap {\n  width: 100%;\n  height: 100%;\n  padding: 0 1rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: inherit;\n  font-style: inherit;\n\n  &.disabled {\n    cursor: not-allowed;\n\n    .icon-arrow {\n      opacity: 0.4;\n    }\n  }\n\n  &:focus-visible {\n    outline: none;\n    // outline: 0.7px solid #766EDA;\n    // border-radius: 2px;\n    // outline: 0.7px solid var(--basic-button-hover);\n    // border-radius: 2px;\n    // user-select: auto;\n    // display: table-cell;\n    // vertical-align: middle;\n\n    &:empty {\n      //   line-height: 120%;\n\n      //   box-sizing: border-box;\n      //   text-align: left;\n    }\n\n    &:hover {\n      // outline: 2px solid var(--basic-button-hover);\n    }\n  }\n}\n\n.value {\n  height: auto;\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n  color: var(--black);\n  flex-grow: 1;\n\n  &.placeholder {\n    color: var(--grey-text);\n  }\n}\n\n.icon-arrow {\n  font-size: 1.8rem;\n  color: var(--dark);\n  margin-left: 0.8rem;\n}\n\n.dropdown {\n  max-height: 30.2rem;\n  background: var(--white);\n  border-radius: 0.8rem;\n  box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1);\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 5.1rem;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  overflow: auto;\n}\n\n.option {\n  min-height: 4.8rem;\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  color: var(--black);\n  padding: 0 1.5rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: var(--basic-button-hover);\n  }\n\n  &.active {\n    background: var(--primary-10);\n    cursor: default;\n  }\n\n  &.disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
